<section class="row block padding-bottom-30 acctIntegration-xeRoSteps" (scroll)="onScrollDiv($event)"
    [ngClass]="divClass">
    <div class="col-md-12 no-padding-right-left doc" id="wizard-pages" #wizardDiv>
        <div [id]="'step-guide-' + item.stepNum" class="row margin-top-0 margin-bottom-0 " *ngFor="let item of wizardDetails" #stepsDiv
            (click)="navigateToStep(item)"
            [ngClass]="{'active': item.stepNum == item.highlightStep , 'disabled': item.isDisabled}">
            <ul class="margin-topBottom-10 w-100pc d-flex justify-content-start" [id]="item.stepNum">
                <li class="padding-right-10">
                    <div class="padding-10 d-block" style="padding-left:0 !important;">
                        <span class="padding-right-5" [ngClass]="{'fw-700': !item.isDisabled}">{{
                            item.stepName}}</span> <span
                            class="badge badge-theme svg-24 position-relative top--2px bg-black"><span
                                class="badge-count">{{item.stepNum}}</span></span>
                    </div>
                </li>
                <li class="w-55pc padding-top-5">
                    <p class="float-left margin-top-5 f-16 " [ngClass]="item.stepClass">
                        {{ item.stepDesc }}<span class="color-red" *ngIf="item.isStepMandatory">*</span>
                        <span class="cursor-pointer" *ngIf="item.isInfoIcon">
                            <i class="fas fa-info-circle text-mustard padding-left-3" placement="right"
                                [ngbPopover]="popContent" container="body" triggers="mouseenter:mouseleave">
                            </i>
                        </span>

                        <ng-template #popContent>
                            <div [innerHTML]="sanitizerHtml(item.infoIconMsg)"></div>
                        </ng-template>


                        <small class="d-block color-grey padding-top-3" *ngIf="item.stepDescMessage"
                            [innerHTML]="sanitizerHtml(item.stepDescMessage)"></small>
                    </p>
                    <div class="message-box w-22pc" *ngIf="isFirstLoad && item.stepExtraMessage">
                        <div [innerHTML]="sanitizerHtml(item.stepExtraMessage)">
                        </div>
                        <p class="mt-4"><button (click)="fnCloseMessage(item,$event)"
                                class="btn btn-primary f-11 mx-auto mt-2">{{ 'label_dismiss' | translate}}</button></p>
                    </div>
                </li>
                <li class="w-25pc ml-3">
                    <ul class="d-flex justify-content-start w-100pc">
                        <li class="float-left ">
                            <span class="lH-40">
                                <i [ngClass]="item.iconClass" ngbTooltip="{{ item.iconTooltip}}" container="body"
                                    tooltipClass="my-custom-class" placement="{{ item.iconPlacement}}">
                                </i>
                            </span>
                        </li>
                        <li class="ml-3 mt-2 float-left d-flex w-100pc flex-column" *ngIf="!item.isProgressBar">
                            <div class="progress height-10px w-100pc no-padding-right-left"
                                *ngIf="item.progressbarType">
                                <ngb-progressbar style="width:100%" type="{{ item.progressbarType}}"
                                    [value]="item.progressbarValue" [max]="100">
                                </ngb-progressbar>
                            </div>
                            <div class="d-flex align-items-top">
                                <span class="f-11 padding-top-3 fw-600 w-100pc"
                                    [innerHTML]="sanitizerHtml(item.progressbarMessage)">                                  
                                </span>
                                <button *ngIf="item.showButton" (click)="onButtonClick($event)" class="btn eod-btn-primary f-11 btn-sm ml-1 mt-1">
                                    {{ "text_view_invoice_receipt" | translate : param }}
                                </button>
                            </div>
                        </li>
                        <!-- <li class="ml-3 mt-1 float-left d-flex w-100pc flex-column" *ngIf="item.isProgressBar">
                            <p class="float-left margin-top-5 f-14" >
                                {{ item.comingSoonDesc }}
                            </p>
                        </li>                                  -->
                    </ul>
                </li>
                <li class="float-left lH-40 top-5px position-relative w-2pc" style="margin-left: 3rem !important;">
                    <span class="lH-40">
                        <img src="assets/images/wizard-crown.svg" alt="new" *ngIf="isEssential && item.isStepMandatory">
                    </span>
                </li>
            </ul>
        </div>
    </div>
</section>